// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-bg[data-v-7c92c2ec] {\n  height: 40px;\n  width: 40px;\n  background-color: #272829;\n  border-radius: 50%;\n}\n.green[data-v-7c92c2ec] {\n  background-color: #2aa665 !important;\n}\n.orange[data-v-7c92c2ec] {\n  background-color: #f2c97d;\n  color: #000;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
